/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getUploadLimits.defs.js'
export * as $defs from './getUploadLimits.defs.js'
